import type { OptionsMap } from '~/types/elementsUi'

export const excludedPopupPages: string[] = [
  '/registreren',
  '/account',
  '/login',
  '/404',
  '/goede-voornemens',
  '/admin'
]

export const hardcodedFocusMunicipalities: OptionsMap[] = [
  { id: '/gemeente/altena', name: 'Altena' },
  { id: '/gemeente/amstelveen', name: 'Amstelveen' },
  { id: '/gemeente/apeldoorn', name: 'Apeldoorn' },
  { id: '/gemeente/breda', name: 'Breda' },
  { id: '/gemeente/buren', name: 'Buren' },
  { id: '/gemeente/de-ronde-venen', name: 'De Ronde Venen' },
  { id: '/gemeente/delft', name: 'Delft' },
  { id: '/gemeente/den-bosch', name: 'Den Bosch' },
  { id: '/gemeente/den-haag', name: 'Den Haag' },
  { id: '/gemeente/den-helder', name: 'Den Helder' },
  { id: '/gemeente/doetinchem', name: 'Doetinchem' },
  { id: '/gemeente/eemsdelta', name: 'Eemsdelta' },
  { id: '/gemeente/enschede', name: 'Enschede' },
  { id: '/gemeente/gooise-meren', name: 'Gooise Meren' },
  { id: '/gemeente/haarlemmermeer', name: 'Haarlemmermeer' },
  { id: '/gemeente/heerde', name: 'Heerde' },
  { id: '/gemeente/heerenveen', name: 'Heerenveen' },
  { id: '/gemeente/heerlen', name: 'Heerlen' },
  { id: '/gemeente/hilversum', name: 'Hilversum' },
  { id: '/gemeente/katwijk', name: 'Katwijk' },
  { id: '/gemeente/leiden', name: 'Leiden' },
  { id: '/gemeente/leidschendam-voorburg', name: 'Leidschendam-Voorburg' },
  { id: '/gemeente/maastricht', name: 'Maastricht' },
  { id: '/gemeente/middelburg', name: 'Middelburg' },
  { id: '/gemeente/nieuwegein', name: 'Nieuwegein' },
  { id: '/gemeente/nijmegen', name: 'Nijmegen' },
  { id: '/gemeente/purmerend', name: 'Purmerend' },
  { id: '/gemeente/rijswijk', name: 'Rijswijk' },
  { id: '/gemeente/schiedam', name: 'Schiedam' },
  { id: '/gemeente/tiel', name: 'Tiel' },
  { id: '/gemeente/utrecht', name: 'Utrecht' },
  { id: '/gemeente/velsen', name: 'Velsen' },
  { id: '/gemeente/vlaardingen', name: 'Vlaardingen' },
  { id: '/gemeente/woerden', name: 'Woerden' },
  { id: '/gemeente/zaanstad', name: 'Zaanstad' },
  { id: '/gemeente/zoetermeer', name: 'Zoetermeer' }
]

// Add recipes that should not be shown
// Leave 'index' in the array
export const omittedRecipeKeys = ['index', 'slug'] as const
